import BaseApi from '@/api/BaseApi'

export default class Answer extends BaseApi {
  getApiPath () {
    return '/quiz/answer.php'
  }

  getMock () {
    return {
      data: {
        'correct_information': [],
        'incorrect_information': { 'hint_url': 'https://www.nepia.co.jp/fsc/' },
        'res': 0,
        'msg': '',
        'debug_msg': 'Game\\Json\\Res\\Api\\Quiz\\Answer Response Message Success',
        'server_time': 1563512156,
        'redirect_path': '',
        'is_correct': false
      }
    }
  }

  /**
   * パラメータ作成
   * @param token
   * @param qmId
   * @param qsmId
   * @returns {FormData}
   */
  static makeParam (token, qmId, qsmId) {
    const params = new FormData()
    params.append('token', token)
    params.append('qm_id', qmId)
    params.append('qsm_id', qsmId)

    return params
  }
}
